<template>
  <div class="container is-max-hd">
    <b-notification type="is-info" :closable="false">
      This inquiry was last verified on {{ formattedDate }} and is out of date. Please resubmit for
      the most current data.
      <br />
      <router-link :to="{ name: 'InquiryCopy', params: { id: inquiryId } }">
        Re-run Inquiry
      </router-link>
      or
      <router-link :to="{ name: 'InquiryList' }">Return to list</router-link>
    </b-notification>
  </div>
</template>

<script>
export default {
  name: 'InquiryExpired',
  props: {
    inquiryId: String,
    createdAt: Date,
  },
  computed: {
    formattedDate() {
      if (!this.createdAt) return '';
      const date = new Date(this.createdAt);
      return date.toLocaleDateString('en-US', {
        month: '2-digit',
        day: '2-digit',
        year: 'numeric',
      });
    },
  },
};
</script>
